import { render, staticRenderFns } from "./previewPage.vue?vue&type=template&id=b57d7ca0&"
import script from "./previewPage.vue?vue&type=script&lang=js&"
export * from "./previewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports